import { gql } from '@apollo/client';

export const UpdateTagsInfo = gql`
  mutation UpdateTagsInfo($updateTagsInfo: UpdateTagsData!) {
    updateTagsInfo(updateTagsInfo: $updateTagsInfo)
  }
`;

export const UpdateFreemiumInfo = gql`
  mutation UpdateFreemiumInfo($updateFreemiumData: UpdateFreemiumData!) {
    updateFreemiumInfo(updateFreemiumData: $updateFreemiumData)
  }
`;

export const UpdateCreditInfo = gql`
  mutation UpdateCreditInfo($updateCreditInfo: UpdateCreditData!) {
    updateCreditInfo(updateCreditInfo: $updateCreditInfo)
  }
`;

/**
{
  "data": {
    "liveLink": null,
    "isLive": null
  }
} 
 */

export const UpdateLiveLink = gql`
  mutation UpdateLiveLink($data: UpdateLiveLinkInput!) {
    updateLiveLink(data: $data)
  }
`;

export const DeleteCreditsSettings = gql`
mutation DeleteCreditsSettings($id: ObjectId!) {
  deleteCreditsSettings(_id: $id) {
    _id
  }
}`;

export const CreateCreditsSettings = gql`
mutation CreateCreditsSettings($input: CreateCreditsSettingsInput!) {
  createCreditsSettings(input: $input) {
    _id
  }
}`;

export const UpdateCreditsSettings = gql`
mutation UpdateCreditsSettings($input: UpdateCreditsSettingsInput!) {
  updateCreditsSettings(input: $input) {
    _id
  }
}
`;

export const ClaimedCredit = gql`
mutation ClaimedCredit($claimedCreditId: ObjectId!) {
  claimedCredit(id: $claimedCreditId) {
    _id
  }
}`;